/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { ActivationAdminAccountRequestDto } from '../model/activationAdminAccountRequestDto';
import { CheckEmailActivationAdminAccountRequestDto } from '../model/checkEmailActivationAdminAccountRequestDto';
import { CheckEmailActivationAdminAccountResponseDto } from '../model/checkEmailActivationAdminAccountResponseDto';
import { CheckUserTokenRequestDto } from '../model/checkUserTokenRequestDto';
import { ForgotPasswordRequestDto } from '../model/forgotPasswordRequestDto';
import { ForgotPasswordResponseDto } from '../model/forgotPasswordResponseDto';
import { LoginRequestDto } from '../model/loginRequestDto';
import { LoginResponseDto } from '../model/loginResponseDto';
import { ResetPasswordRequestDto } from '../model/resetPasswordRequestDto';
import { ValidationError } from '../model/validationError';


@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   */
  public authenticationActivationAdminAccountPost$(body: ActivationAdminAccountRequestDto): Observable<string> {
    return this.api.post(`${apiBaseUrl()}/authentication/activation-admin-account`, body, undefined, true);
  }
  /**
   */
  public authenticationCheckEmailActivationAdminAccountPost$(body: CheckEmailActivationAdminAccountRequestDto): Observable<CheckEmailActivationAdminAccountResponseDto> {
    return this.api.post(`${apiBaseUrl()}/authentication/check-email-activation-admin-account`, body, undefined, true);
  }
  /**
   */
  public authenticationCheckUserTokenPost$(body: CheckUserTokenRequestDto): Observable<string> {
    return this.api.post(`${apiBaseUrl()}/authentication/check-user-token`, body, undefined, true);
  }
  /**
   */
  public authenticationForgotPasswordPost$(body: ForgotPasswordRequestDto): Observable<ForgotPasswordResponseDto> {
    return this.api.post(`${apiBaseUrl()}/authentication/forgot-password`, body, undefined, true);
  }
  /**
   */
  public authenticationLoginPost$(body: LoginRequestDto): Observable<LoginResponseDto> {
    return this.api.post(`${apiBaseUrl()}/authentication/login`, body, undefined, true);
  }
  /**
   * [Authorize] type: http
   */
  public authenticationLogoutPost$(): Observable<any> {
    return this.api.post(`${apiBaseUrl()}/authentication/logout`, undefined, undefined);
  }
  /**
   */
  public authenticationResetPasswordPost$(body: ResetPasswordRequestDto): Observable<string> {
    return this.api.post(`${apiBaseUrl()}/authentication/reset-password`, body, undefined, true);
  }
}
